const EMAIL = 'hello@belonghome.com';
const DEFAULT_PHONE = '6508859166';

export { DEFAULT_PHONE, EMAIL };
